/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';
import {
  PieChart, Pie, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { map, sum } from 'lodash';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const style = {
  width: 250,
    top: '0',
  lineHeight: '24px',
};

const renderLegend = ({ payload }) => (
  <ul className="dashboard__chart-legend">
    {

      payload.map((entry, index) => (
        <li key={`item-${index}`}><span style={{ backgroundColor: entry.color }} />{entry.payload.value}&nbsp;{entry.value}</li>
      ))
    }
  </ul>
);

renderLegend.propTypes = {
  payload: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string,
    vslue: PropTypes.string,
  })).isRequired,
};

class AssetsSummary extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    dir: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      x: 0,
      y: 0,
    };
  }

  onMouseMove = (e) => {
    const { dir } = this.props;
    if (e.tooltipPosition) {
      this.setState({ x: dir === 'ltr' ? e.tooltipPosition.x : e.tooltipPosition.x / 10, y: e.tooltipPosition.y });
    }
  };

  render() {
    const { x, y } = this.state;
    const { t, assetSummaryData } = this.props;

    let totalAssets = 0;
    const data01 = [];

    const fillColor = {
      "Healthy": '#63c9af',
      "Missing Data": '#ffd876',
      "Major Issues": '#FF9033',
      "Critical Issues": '#e16975',
      "Status Down": '#555555',
    };

    let i = 0;
    map(assetSummaryData , (item, index)=> {
      totalAssets = totalAssets + item;
      data01.push({
        name: index,
        value: item,
        fill: fillColor[index]
      });
    });

    return (
      <Col lg={6} xs={6} sm={6}>
          <div className="white-bg">
            <div className="title-details">
              <div className="col-lg-6 col-sm-6 col-xs-6">
                <h4>Asset Summary</h4>
              </div>
              <div className="col-lg-6 text-right col-sm-6 col-xs-6">
              </div>
            </div>
            <div className="pro top-m" style={{ display: 'block' }}>
              <div className="dashboard__visitors-chart">
                <ResponsiveContainer className="dashboard__chart-pie"  >
                  <PieChart className="dashboard__chart-pie-container">
                    <Tooltip position={{ x, y }} />
                    <Pie
                        data={data01}
                        dataKey="value"
                        cx={50}
                        cy={140}
                        innerRadius={100}
                        outerRadius={130}
                        onMouseMove={this.onMouseMove}
                    />
                    <Legend layout="horizontal" align="right" wrapperStyle={style} content={renderLegend} />
                  </PieChart>
                </ResponsiveContainer>
                  <div className="dashboard__visitors-chart_label">
                      <p className="dashboard__visitors-chart-number">{totalAssets}</p>
                      <p className="dashboard__visitors-chart-title"> <span>Total Assets</span></p>
                  </div>
              </div>
            </div>
          </div>
      </Col>

    );
  }
}


export default withTranslation('common')(AssetsSummary);
